import React, { useEffect } from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import element4Mob from "../assets/images/element_4_mob.png"
import element3 from "../assets/images/element-3.svg"
import line from "../assets/images/line.svg"
import elemantSol from "../assets/images/element_solutions_mob.png"
import puzzleImg from "../assets/images/puzzle_image.png"
import marketPlace from "../assets/images/Browse-Marketplace-08.svg"
import ownPortal from "../assets/images/own_portal.svg"
import elemantSolMob from "../assets/images/element_solutions.svg"
import undormMarketPlace from "../assets/images/Undorm-Marketplace-07.svg"
import appartmentFind from "../assets/images/sol_find_apartments-06.svg"
import diffImg from "../assets/images/different_image.png"
import apporvalProcess from "../assets/images/approval_process_icon.svg"
import tourAppartments from "../assets/images/tour_apartments.svg"
import findingApp from "../assets/images/finding_apartment_icon.svg"
import leasedTerm from "../assets/images/leased_term_icon.svg"
import eleDiff from "../assets/images/element_different.png"
import "aos/dist/aos.css"
import AOS from "aos"
import { FaTimes } from "react-icons/fa"
import Lock from "../components/Lock"
import { RiArrowRightSLine } from "react-icons/ri"

const Index = () => {
  useEffect(() => {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 100,
      throttleDelay: 99,
      offset: 120,
      delay: 0,
      duration: 1200,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    })
  }, [])

  return (
    <Layout>
      <Seo Sitetitle="Home" />
      <>
        <div
          style={{
            zIndex: 100000,
            position: "fixed",
            top: "calc(50% - 250px)",
            right: 0,
            transition: "width 300ms ease-out",
            width: 0,
          }}
          data-qa="side_panel"
        >
          {" "}
          <a
            className="typeform-share button"
            href="https://form.typeform.com/to/RwKa5h9V?typeform-medium=embed-snippet"
            data-mode="side_panel"
            style={{
              boxSizing: "border-box",
              position: "absolute",
              top: 300,
              width: 200,
              height: 48,
              padding: "0 20px",
              margin: 0,
              cursor: "pointer",
              background: "#009DFF",
              borderRadius: "4px 4px 0px 0px",
              boxShadow:
                "0px 2px 12px rgba(0, 0, 0, 0.06), 0px 2px 4px rgba(0, 0, 0, 0.08)",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              transform: "rotate(-90deg)",
              transformOrigin: "bottom left",
              color: "#fff",
              textDecoration: "none",
              zIndex: 9999,
            }}
            data-submit-close-delay={2}
            data-width={320}
            data-height={500}
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <span
              className="icon"
              style={{
                width: 32,
                position: "relative",
                textAlign: "center",
                transform: "rotate(90deg) scale(0.85)",
                left: "-8px",
              }}
            >
              {" "}
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginTop: 10 }}
              >
                {" "}
                <path
                  d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z"
                  fill="white"
                />{" "}
              </svg>{" "}
            </span>{" "}
            <span
              style={{
                textDecoration: "none",
                fontSize: 18,
                fontFamily: "Helvetica,Arial,sans-serif",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                textAlign: "center",
                WebkitFontSmoothing: "antialiased",
                MozOsxFontSmoothing: "grayscale",
                color: "#fff",
              }}
            >
              {" "}
              Get Started{" "}
            </span>{" "}
          </a>{" "}
        </div>

        <section className="main-section overflow-hidden">
          <Lock />
          <div
            className="position-relative overflow-hidden"
            data-aos="fade-right"
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="row">
                    <div className="offset-md-3 offset-2 col-9">
                      <h3
                        className="main-heading-main medium mt-3"
                        data-aos="fade-down"
                      >
                        The most enjoyable apartment search process ever...
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-4 position-relative">
                <img
                  src={line}
                  className="img-fluid mob_line"
                  data-aos="fade-left"
                  alt="Line"
                />
                <div className="col-lg-4 col-md-6" data-aos="fade-right">
                  <div className="d-flex">
                    <h2 className="numbers">1</h2>
                    <div>
                      <h2 className="main-heading-main small">
                        Search{" "}
                        <span role="img" aria-label="search">
                          🔎
                        </span>
                      </h2>
                      <ul className="list-unstyled buying-ways p-0 ">
                        <li className="d-flex">
                          <RiArrowRightSLine className="right-arrow-icon" />
                          <span>
                            Schedule an introductory <br /> call or browse our{" "}
                            <br /> marketplace.
                          </span>
                        </li>
                        <li className="d-flex">
                          <RiArrowRightSLine className="right-arrow-icon" />
                          <span>
                            We deep dive into <br /> your preferences to find{" "}
                            <br /> the perfect apartments.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 adjust-margin col-md-6 mt-lg-2 position-relative"
                  data-aos="fade-up"
                >
                  <img
                    src={line}
                    className="img-fluid mt-3 d-lg-inline d-none img-margin"
                    alt="Line"
                  />
                  <img
                    src={element4Mob}
                    className="img-fluid element_4_img"
                    alt="Right Wraper"
                  />
                  <div className="d-flex justify-content-lg-center mt-lg-2">
                    <h2 className="numbers number-2">2</h2>
                    <div>
                      <h2 className="main-heading-main small">
                        Tour{" "}
                        <span role="img" aria-label="search">
                          👀
                        </span>{" "}
                      </h2>
                      <ul className="list-unstyled buying-ways p-0">
                        <li className="d-flex">
                          <RiArrowRightSLine className="right-arrow-icon" />
                          <span>
                            Curated tour of 5-10 apartments <br /> viewed all in
                            one day.
                          </span>
                        </li>
                        <li className="d-flex">
                          <RiArrowRightSLine className="right-arrow-icon" />
                          <span>
                            White-glove service including <br /> Ubers between
                            places and <br /> a bite to eat.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 adjust-margin column-3 col-md-6 pl-lg-0"
                  data-aos="fade-right"
                >
                  <div className="d-flex">
                    <h2 className="numbers number-2">3</h2>
                    <div>
                      <h2 className="main-heading-main small">
                        Unlock{" "}
                        <span role="img" aria-label="search">
                          🔑
                        </span>{" "}
                      </h2>
                      <ul className="list-unstyled buying-ways p-0 ">
                        <li className="d-flex">
                          <RiArrowRightSLine className="right-arrow-icon" />
                          <span>
                            Painless application process <br /> guided by your
                            dedicated <br /> Undorm assistant.
                          </span>
                        </li>
                        <li className="d-flex">
                          <RiArrowRightSLine className="right-arrow-icon" />
                          <span>
                            Collect the keys and get <br /> moved in. We can
                            help <br /> with moving too!
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row margin-top pb-4" data-aos="fade-left">
                <div className="col-12 text-center my-5 btns-index">
                  <a
                    href="#sla"
                    className="btn smooth-scrool wraper-button me-3"
                    data-target="student-looking-for-appartment"
                  >
                    I Want to Find An Apartment
                  </a>
                  <a
                    href="#sma"
                    className="btn smooth-scrool wraper-button ml-lg-1 mt-lg-0 mt-3"
                    data-target="student-moving-out-of-appartment"
                  >
                    I Want to List My Apartment
                  </a>
                </div>
              </div>
            </div>
            <img
              src={element3}
              className="img-fluid main-wraperp-img-2"
              alt="I Want to List My"
            />
          </div>
        </section>

        <section className="main-wraper solutions-section overflow-hidden mb-5">
          <h2
            className="text-end bordered-text solution-txt"
            data-aos="fade-down"
          >
            SOLUTIONS
          </h2>
          <div className="wave-img-bg">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-5 col-6" data-aos="fade-left">
                  <h2 className="main-heading large">
                    Rental Solutions that Put Students First
                  </h2>
                  <div className="row mt-3">
                    <div className="offset-lg-2 col-lg-3 col-md-6 col-5 pt-2">
                      <hr className="text-hr" />
                    </div>
                    <div className="col-lg-6 col-md-6 col-7 pl-md-4">
                      <ul className="list-unstyled buying-ways p-0">
                        <li className="d-flex" style={{ fontSize: 18 }}>
                          No BS. <br /> All the best apartments. <br /> Only on
                          your terms.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className="offset-lg-2 col-lg-6 space-left position-relative"
                  data-aos="fade-right"
                  id="sla"
                >
                  <img
                    src={elemantSol}
                    className="right-wraper-img-mob"
                    alt="the best apartments."
                  />
                  <div
                    className="black-line"
                    id="student-looking-for-appartment"
                  />
                  <h3 className="main-heading-main medium mt-3 space-bottom">
                    Students Looking <br /> for an Apartment
                  </h3>
                </div>
              </div>
            </div>
            <img
              src={puzzleImg}
              className="img-fluid pulze-img"
              data-aos="fade-down"
              alt="Students Looking for an Apartment"
            />
          </div>
          <div className="container">
            <div className="row">
              <div
                className="col-lg-4 col-md-5 safari-margin-top offset-lg-2 images-row"
                data-aos="fade-right"
              >
                <img
                  src={marketPlace}
                  className="img-fluid wraper-img-1"
                  alt="Browse our Marketplace"
                />
              </div>
              <div
                className="col-lg-5 col-md-7 safari-margin-top d-flex justify-content-center flex-column"
                data-aos="fade-down"
              >
                <h2 className="main-heading-main small">
                  Browse our Marketplace
                </h2>
                <ul className="list-unstyled buying-ways section-3-inner ">
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>Pre-lease months ahead of time.</span>
                  </li>
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      Filter by student specific criteria <br /> (like walking
                      distance to campus).
                    </span>
                  </li>
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      Found something better on another site? <br /> Send a link
                      and we make it happen.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row row-col-rev mt-lg-5 mt-4 pt-0">
              <div
                className="col-lg-5 col-md-5 safari-margin-top right-home offset-lg-2 d-flex justify-content-center flex-column"
                data-aos="fade-up"
              >
                <h2 className="main-heading-main small">
                  Your Very Own Portal
                </h2>
                <ul className="list-unstyled buying-ways section-3-inner ">
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      Understand where you are in the process <br /> with a
                      tracker and to-do list.
                    </span>
                  </li>
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>Submit documents easily and securely.</span>
                  </li>
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      Add your roommates and guarantors <br /> to centralize
                      information.
                    </span>
                  </li>
                </ul>
              </div>
              <div
                className="col-lg-4 col-md-7 safari-margin-top images-row"
                data-aos="fade-left"
              >
                <img
                  src={ownPortal}
                  className="img-fluid wraper-img-1 left-home"
                  alt="Fully furnish your apartment"
                />
              </div>
            </div>
          </div>
          <div className="position-relative">
            <img
              src={elemantSolMob}
              className="img-fluid solutions-img"
              alt="solutions"
            />
            <div className="container" id="sma">
              <div className="row">
                <div id="student-moving-out-of-appartment" />
                <div
                  className="offset-lg-2 col-lg-6 space-left"
                  data-aos="fade-right"
                >
                  <div className="black-line mt-0" />
                  <h3 className="main-heading-main medium mt-3 space-bottom">
                    Students Moving <br /> Out of an Apartment
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div
                className="col-lg-4 col-md-5 safari-margin-top offset-lg-2 images-row"
                data-aos="fade-down"
              >
                <img
                  src={undormMarketPlace}
                  className="img-fluid wraper-img-1"
                  alt="List on the Undorm marketplace"
                />
              </div>
              <div
                className="col-lg-5 col-md-7 safari-margin-top d-flex justify-content-center flex-column"
                data-aos="fade-left"
              >
                <h2 className="main-heading-main small">
                  List on the Undorm marketplace
                </h2>
                <ul className="list-unstyled buying-ways section-3-inner ">
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      Moving out in 1,2,4,8...12 months? <br /> Find the next
                      tenant on Undorm.
                    </span>
                  </li>
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      Make at least $1,000 when you help your <br /> landlord
                      find the next renter.
                    </span>
                  </li>
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      Undorm drives traffic to your listing and <br /> connects
                      everyone involved.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row row-col-rev mt-lg-5 mt-4 pt-0">
              <div
                className="col-lg-5 col-md-5 safari-margin-top right-home offset-lg-2 d-flex justify-content-center flex-column"
                data-aos="fade-up"
              >
                <h2 className="main-heading-main small">
                  Finding your next apartment
                </h2>
                <ul className="list-unstyled buying-ways section-3-inner ">
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      If you’re moving out and moving in, <br /> help yourself
                      twice.
                    </span>
                  </li>
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      Make money when you move out and <br /> save money when
                      you move in.
                    </span>
                  </li>
                  <li className="d-flex">
                    <RiArrowRightSLine className="right-arrow-icon" />
                    <span>
                      We’ll guide you through your next <br /> apartment hunt.
                    </span>
                  </li>
                </ul>
              </div>
              <div
                className="col-lg-4 col-md-7 safari-margin-top images-row"
                data-aos="fade-right"
              >
                <img
                  src={appartmentFind}
                  className="img-fluid wraper-img-1 left-home"
                  alt="Fully furnish your apartment. Either:"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="learn-more text-center mt-3" data-aos="fade-down">
          <h2 className="learn-more-txt">
            Learn More About our Rental Solutions
          </h2>
          <a
            href="https://undorm.typeform.com/to/RwKa5h9V"
            target="_blank"
            rel="noreferrer"
          >
            <button className="btn wraper-button mt-2">
              I Want to Learn More!
            </button>
          </a>
        </section>
        <section className="main-wraper solutions-section overflow-hidden">
          <h2 className="bordered-text text-left" data-aos="fade-left">
            DIFFERENT
          </h2>
          <div className="wave-img-bg left">
            <div className="container">
              <div className="row">
                <div
                  className="col-lg-6 offset-lg-6 offset-md-3 column-z-index col-md-7 col-8 pl-md-0"
                  data-aos="fade-right"
                >
                  <h2 className="main-heading large">
                    What makes Undorm <br /> Different from Everyone Else?
                  </h2>
                  <div className="row mt-3 row-margin-left">
                    <div className="offset-lg-2 col-lg-3 col-3 col-margin-right pt-2">
                      <hr className="text-hr" />
                    </div>
                    <div className="col-lg-6 col-7 pl-lg-4">
                      <ul className="list-unstyled buying-ways p-0">
                        <li className="d-flex" style={{ fontSize: 18 }}>
                          As a NYC renter <br /> your hands were tied, <br />{" "}
                          especially as a student.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="offset-lg-1 offset-md-6 offset-3 adjust-column col-lg-10 col-space-left">
                  <div
                    className="black-line line-space-top"
                    data-aos="fade-down"
                  />
                  <h3
                    className="main-heading-main medium mt-3"
                    data-aos="fade-left"
                  >
                    With Other <br /> Services You..
                  </h3>
                  <ul
                    className="list-unstyled buying-ways section-3-inner space-form-left margin-left "
                    data-aos="fade-up"
                  >
                    <li className="d-flex large-txt">
                      <FaTimes className="times" />
                      <span>Tour apartments that don’t match your needs.</span>
                    </li>
                    <li className="d-flex large-txt">
                      <FaTimes className="times" />
                      <span>
                        Scour your texts and emails for important details.
                      </span>
                    </li>
                    <li className="d-flex large-txt">
                      <FaTimes className="times" />
                      <span>Lease on terms out of your control.</span>
                    </li>
                    <li className="d-flex large-txt">
                      <FaTimes className="times" />
                      <span>Send rent $$$ how you’re told.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <img
              src={diffImg}
              data-aos="fade-down"
              className="img-fluid pulze-img left"
              alt="With Other Services You."
            />
          </div>
        </section>
        <section>
          <div className="container" data-aos="fade-right">
            <div className="row mt-3">
              <div className="offset-lg-3 col-lg-8 offset-md-4 column-padding-left col-md-8 ">
                <div className="d-flex align-items-center pl-lg-1">
                  <hr className="adjust-hr text-hr d-inline-block mr-5" />
                  <h2 className="main-heading-main medium d-inline-block margin-left">
                    So we started Undorm…
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="content-outer position-relative overflow-hidden">
            <div className="container">
              <div className="row mt-5">
                <div className="col-lg-10 mx-auto">
                  <div className="row">
                    <div className="col-lg-5 col-md-6" data-aos="fade-down">
                      <div className="outer-wraper">
                        <img
                          src={apporvalProcess}
                          className="img-fluid wraper-inner-img"
                          alt="Approval Process"
                        />
                        <h2 className="main-heading-main small mt-4">
                          Approval Process
                        </h2>
                        <ul className="list-unstyled buying-ways section-3-inner pl-0">
                          <li className="d-flex bold mb-3">Simplified</li>
                          <li className="d-flex">
                            <RiArrowRightSLine className="right-arrow-icon" />
                            <span>
                              We guide you through the complex paperwork.
                            </span>
                          </li>
                          <li className="d-flex">
                            <RiArrowRightSLine className="right-arrow-icon" />
                            <span>
                              Check out our Resources to get a quick head start.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="col-lg-5 col-md-6 offset-lg-2"
                      data-aos="fade-left"
                    >
                      <div className="outer-wraper">
                        <img
                          src={tourAppartments}
                          className="img-fluid wraper-inner-img"
                          alt="Rent Payments"
                          style={{ transform: "scale(1.25)" }}
                        />
                        <h2 className="main-heading-main small mt-4">
                          Touring Apartments
                        </h2>
                        <ul className="list-unstyled buying-ways section-3-inner pl-0">
                          <li className="d-flex bold mb-3">Streamlined</li>
                          <li className="d-flex">
                            <RiArrowRightSLine className="right-arrow-icon" />
                            <span>
                              Apartments move quickly. Compare the best, back to
                              back.
                            </span>
                          </li>
                          <li className="d-flex">
                            <RiArrowRightSLine className="right-arrow-icon" />
                            <span>
                              Kick back while we handle the scheduling and
                              paperwork.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="col-lg-5 col-md-6 mt-md-5 mt-4"
                      data-aos="fade-up"
                    >
                      <div className="outer-wraper">
                        <img
                          src={findingApp}
                          className="img-fluid wraper-inner-img"
                          alt="Finding Apartments"
                        />
                        <h2 className="main-heading-main small mt-4">
                          Finding Apartments
                        </h2>
                        <ul className="list-unstyled buying-ways section-3-inner pl-0">
                          <li className="d-flex bold mb-3">Revolutionized</li>
                          <li className="d-flex">
                            <RiArrowRightSLine className="right-arrow-icon" />
                            <span>No more last minute uncertainty.</span>
                          </li>
                          <li className="d-flex">
                            <RiArrowRightSLine className="right-arrow-icon" />
                            <span>
                              Pre-lease apartments months to a year in advance.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="col-lg-5 col-md-6 offset-lg-2 mt-md-5 mt-4"
                      data-aos="fade-down"
                    >
                      <div className="outer-wraper">
                        <img
                          src={leasedTerm}
                          className="img-fluid wraper-inner-img"
                          alt="Lease Terms"
                        />
                        <h2 className="main-heading-main small mt-4">
                          Lease Terms
                        </h2>
                        <ul className="list-unstyled buying-ways section-3-inner pl-0">
                          <li className="d-flex bold mb-3">Personalized</li>
                          <li className="d-flex">
                            <RiArrowRightSLine className="right-arrow-icon" />
                            <span>Your apartment, your terms.</span>
                          </li>
                          <li className="d-flex">
                            <RiArrowRightSLine className="right-arrow-icon" />
                            <span>
                              Some apartments available for semester or summer
                              length leases.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              src={eleDiff}
              className="img-fluid different-img"
              alt="differnet right background"
            />
          </div>
        </section>
        <section className="learn-more text-center mt-5" data-aos="fade-right">
          <h2 className="learn-more-txt">Get Started. Find Your Pad.</h2>
          <a
            href="https://undorm.typeform.com/to/RwKa5h9V"
            target="_blank"
            rel="noreferrer"
          >
            <button className="btn wraper-button mt-2">Find My Pad Now!</button>
          </a>
        </section>
      </>
    </Layout>
  )
}

export default Index
